import React, { useEffect, useState } from 'react';
import MobileProfileTopNavigation from './MobileProfileTopNavigation';
import ChangePasswordSection from '../../PageComponent/ProfilePage/ChangePasswordSection';
function MobileChangePassword() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
 
  return (
    <div className='text-coalBlack pt-12'>
        <MobileProfileTopNavigation pageTitle={'Change password'} />
        <ChangePasswordSection />
    </div>
  );
}

export default MobileChangePassword;
